import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { AddWageDialog } from './add-wage-dialog/add-wage-dialog.component';
import { HourlyWageDialogComponent } from './hourly-wage-dialog.component';

export * from './hourly-wage-dialog.component';
export * from './add-wage-dialog/add-wage-dialog.component';

@NgModule({
    declarations: [ HourlyWageDialogComponent, AddWageDialog ],
    imports: [
        CommonModule,
        MatDialogModule,
        TranslateModule,
        MatProgressBarModule,
        MatTableModule,
        MatIconModule,
        GenericInputModule,
        MatButtonModule,
        MatTooltipModule,
        MatSortModule,
    ],
})
export class HourlyWageDialogModule {
}
